export default __webpack_public_path__ + "static/media/room1_1.e5fcd6bb.jpeg";